import React from "react";

// WorkIcon Component
const WorkIcon = ({ fillColor = "#FFFFFF" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    id="work"
    style={{
      width: 20,
      height: 20,
    }}
  >
    <path
      d="M25.377,7.432H21.422a1.277,1.277,0,0,1-1.273-1.149,2.992,2.992,0,0,0-2.984-2.694h-2.33a2.992,2.992,0,0,0-2.984,2.694,1.277,1.277,0,0,1-1.273,1.149H6.623a4,4,0,0,0-4,4V24.411a4,4,0,0,0,4,4H25.377a4,4,0,0,0,4-4V11.432A4,4,0,0,0,25.377,7.432ZM13.841,6.487a1,1,0,0,1,.994-.9h2.33a1,1,0,0,1,.994.9,3.269,3.269,0,0,0,.256.945h-4.83A3.269,3.269,0,0,0,13.841,6.487ZM6.623,9.432H25.377a2,2,0,0,1,2,2v4.946A24.088,24.088,0,0,1,16,19.067a24.069,24.069,0,0,1-11.377-2.69V11.432A2,2,0,0,1,6.623,9.432ZM25.377,26.411H6.623a2,2,0,0,1-2-2V18.629A26.377,26.377,0,0,0,15,21.043v.564a1,1,0,0,0,2,0v-.564a26.377,26.377,0,0,0,10.377-2.414v5.782A2,2,0,0,1,25.377,26.411Z"
      fill={fillColor}
    ></path>
  </svg>
);

// HomeIcon Component
const HomeIcon = ({ fillColor = "#FFFFFF" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    id="home"
    style={{
      width: 20,
      height: 20,
    }}
  >
    <path
      fill={fillColor}
      stroke={fillColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m4 14 9.65-8.78a2 2 0 0 1 2.7 0L26 14"
    ></path>
    <path
      fill={fillColor}
      stroke={fillColor}
      strokeLinejoin="round"
      strokeWidth="2"
      d="M6 12v12a1 1 0 0 0 1 1h5v-8h6v8h5a1 1 0 0 0 1-1V12"
    ></path>
  </svg>
);

// AboutIcon Component
const AboutIcon = ({ fillColor = "#FFFFFF" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    enableBackground="new 0 0 128 128"
    viewBox="0 0 128 128"
    id="about"
    style={{
      width: 20,
      height: 20,
    }}
  >
    <path
      fill={fillColor}
      fillRule="evenodd"
      d="M57.8 45L57.8 45 57.8 45c.2.4.4.8.6 1.1.2.3.5.6.7.9l0 0 0 0c.3.3.6.6 1 .9.3.2.7.5 1.2.6l0 0c.4.2.8.3 1.3.4.5.1.9.1 1.3.1.4 0 .9 0 1.3-.1.4-.1.8-.2 1.1-.4 0 0 .1 0 .1 0 .4-.2.8-.4 1.2-.7.3-.2.6-.5.9-.8 0 0 .1-.1.1-.1.3-.3.5-.6.7-.9.2-.3.4-.6.5-1 0-.1 0-.1.1-.2.2-.4.3-.9.4-1.3.1-.4.1-.9.1-1.3 0-.4 0-.9-.1-1.3-.1-.4-.2-.8-.4-1.3l0 0 0 0c-.3-.7-.7-1.3-1.2-1.8-.1-.1-.1-.1-.2-.2-.3-.3-.6-.5-1-.8-.4-.2-.7-.4-1.1-.6l0 0c-.4-.2-.8-.3-1.2-.4-.5-.1-.9-.1-1.3-.1-.4 0-.9 0-1.3.1-.4.1-.8.2-1.2.4 0 0-.1 0-.1 0-.4.2-.8.4-1.1.6-.4.3-.7.5-1 .8l0 0 0 0c-.3.3-.6.6-.8.9-.2.3-.4.7-.6 1.1l0 0 0 0c-.2.4-.3.8-.4 1.2l0 0 0 0c-.1.5-.1.9-.1 1.3 0 .4 0 .9.1 1.3C57.5 44.2 57.7 44.6 57.8 45zM71.7 81.6h-2.3V57.1c0-1.4-1.1-2.6-2.6-2.6H56.3c-1.4 0-2.6 1.1-2.6 2.6v5.4c0 1.4 1.1 2.6 2.6 2.6h2.1v16.6h-2.1c-1.4 0-2.6 1.1-2.6 2.6v5.4c0 1.4 1.1 2.6 2.6 2.6h15.4c1.4 0 2.6-1.1 2.6-2.6v-5.4C74.3 82.8 73.1 81.6 71.7 81.6z"
      clipRule="evenodd"
    ></path>
    <path
      fill={fillColor}
      fillRule="evenodd"
      d="M64,9.3C33.8,9.3,9.3,33.8,9.3,64s24.5,54.7,54.7,54.7
          c30.2,0,54.7-24.5,54.7-54.7S94.2,9.3,64,9.3z M64,111.5c-26.2,0-47.5-21.3-47.5-47.5S37.8,16.5,64,16.5s47.5,21.3,47.5,47.5
          S90.2,111.5,64,111.5z"
      clipRule="evenodd"
    ></path>
  </svg>
);

// Exporting all icons
export { WorkIcon, HomeIcon, AboutIcon };
